import { CreditCardDTO } from '@/data/DTOs/schedule/CreditCardDTO';
import { DoctorDTO } from '@/data/DTOs/schedule/DoctorDTO';
import { ScheduleDTO } from '@/data/DTOs/schedule/ScheduleDTO';
export interface SchedulingProps {
  schedule: ScheduleDTO;
  setSchedule: (user: ScheduleDTO) => void;
  setIsValid: (isValid: boolean) => void;
  internalObject: SchedulingConfirmInformationInterface;
  setInternalObject: (details: SchedulingConfirmInformationInterface) => void;
  setCurrentStep: (step: number) => void;
  changeInternalStep: (next: boolean) => void;
}

export interface SchedulingWarningsProps {
  loading: boolean;
  setLoading: (loading: boolean) => void;
  setShowWarning: (showWarning: boolean) => void;
  setWarningMessage: (warningMessage: string) => void;
  setRightButtonTitle: (rightButtonText: string) => void;
  setRightButtonAction: (rightButtonAction: () => void) => void;
  setLeftButtonTitle?: (leftButtonText: string) => void;
  setLeftButtonAction?: (leftButtonAction: () => void) => void;
}

export interface SchedulingStepsInterface {
  title?: string;
  subTitle?: string;
  page?: React.ComponentType<SchedulingProps & SchedulePopUpInterface>;
  pageLoading?: React.ComponentType<
    SchedulingProps & SchedulingWarningsProps & SchedulePopUpInterface
  >;
  addonNext?: React.ComponentType<
    SchedulingProps & SchedulingWarningsProps & SchedulePopUpInterface
  >; // qual tela deve ir
  addonBack?: React.ComponentType<
    SchedulingProps & SchedulingWarningsProps & SchedulePopUpInterface
  >; // qual tela deve voltar
  nextPopUp?: boolean; // mostrar pop up antes de avançar
}

export interface SchedulingConfirmItems {
  // Cópia do InfoBoxProps
  iconLeft: React.ReactNode;
  title: string;
  text: string;
  subText?: string;
  iconRight?: React.ReactNode;
  onRightIconClick?: () => void;
}
export interface SchedulingConfirmInformationInterface {
  patientName: string;
  patientPhoto: string;
  scheduleType: string;
  address: string;
  doctorName: string;
  date: Date;
  time: string;
  price: string;
  paymentType: string;
  creditCard?: string;
  creditCardDTO?: CreditCardDTO;
  addressWhatsapp?: string;
  allDoctors?: DoctorDTO[];
  passedDateSelect: boolean;
  banner?: string;
  cardLast4Digits?: string;
  categoryId: string;
}

export interface SchedulePopUpInterface {
  setShowPopUp: (showPopUp: boolean) => void;
  showPopUp: boolean;
  setNextStep?: (nextStep: boolean) => void;
  buttonActionArray?: (() => void)[];
}

export const ScheduleAppointmentType = {
  InPerson: 1,
  Online: 2,
  isOnline(appointmentTypeId: number): boolean {
    return appointmentTypeId === this.Online;
  },
  returnString(appointmentTypeId: number): string {
    return appointmentTypeId === this.Online
      ? 'Online'
      : 'schedule_choose_appointment_type_in_person';
  },
} as const;
